import { Select } from "@mui/material";
import React, { useState } from "react";
import { MenuItem } from "@mui/material";
import "./BusinessUnitSelection.scss";
import { useDispatch } from "react-redux";
import { fetchBusinessUnitPreference } from "../../../services/orgService";
import { AUTH_REDUCER } from "../../../constants/enums";
const BusinessUnitSelection = () => {
  const dispatch = useDispatch();
  const businessUnits =
    localStorage.getItem("businessUnits") &&
    JSON.parse(localStorage.getItem("businessUnits") || "{}");
  //const [bunitsList, setBunitsList] = useState(localStorage.getItem("businessUnits") && JSON.parse(localStorage.getItem("businessUnits")||"{}"));
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState({
    id:
      localStorage.getItem("currentBusinessUnit") &&
      JSON.parse(localStorage.getItem("currentBusinessUnit") || "{}").id,
  });

  const handleSelectChange = (value: number) => {
    if (value) {
      localStorage.setItem(
        "currentBusinessUnit",
        JSON.stringify({ id: value })
      );
      fetchBusinessUnitPreference(value).then((res: any) => {
        localStorage.setItem(
          "categoryPreferences",
          JSON.stringify(res.data.categoryPreferences)
        );
        localStorage.setItem("preference", JSON.stringify(res.data.preference));
        setSelectedBusinessUnit({ id: value });
        dispatch({ type: AUTH_REDUCER.SET_CURRENT_BUNIT, payload: value });
      });
    }
  };

  return (
    <Select
      id="pw-e2e-businessunitselection"
      className="pw-businessunitselection"
      onChange={(event) => handleSelectChange(event.target.value)}
      value={selectedBusinessUnit?.id}
      disabled={businessUnits?.length === 1}
    >
      {businessUnits
        .sort((a: any, b: any) => {
          return a.name.localeCompare(b.name);
        })
        ?.map((eachUnit: any) => (
          //@ts-ignore - necessary to load object into value
          <MenuItem key={eachUnit.id} value={eachUnit.id}>
            {eachUnit.name}
          </MenuItem>
        ))}
    </Select>
  );
};

export default BusinessUnitSelection;
